module.exports = __webpack_public_path__ + "static/img/IQ@3x.6020ec2f.png";